module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aa5e1a2ea01301cb280d194cf72bac3f.png";